import { createTheme, adaptV4Theme } from "@mui/material/styles";
const theme = createTheme(adaptV4Theme({

  palette: {
    primary: {
      main: "#0064ac",
      light: "#04BCD9",
      dark: "#008051",
      contrastText: "#fff"
    },
    secondary: {
      main: "#6c757d",
      light: "#3f51b5",
      dark: "#008051",
      contrastText: "#fff"
    },
    tertiary: {
      main: "#3f51b5"
    }
  }
}));

export default theme;
